module.exports = __webpack_public_path__ + "img/Academico.e9669958.png";